import { FormContainerEnriched, FormState } from 'src/types'

/**
 * Проверка данных текущей открытой формы в редаксе на наличие в ней открытых контейнеров
 * @param formCode Код текущей открытой формы
 * @param formStates Текущее состояние редакса
 * @returns Результат операции Array.some() над данными контейнеров: true, если хотя бы у одного expandable контейнера open === true, иначе false
 */
export const getInitialExpandedContainers = (
  formCode: string | undefined,
  formStates: FormState,
  containers: FormContainerEnriched[]
): boolean => {
  if (!formCode || !containers?.length) {
    return false
  }

  const currentFormData = formStates[formCode]?.containers || {}

  return containers.some(container => {
    if (!container.expandable) return false
    const state = currentFormData[container.id]

    return state?.open === true
  })
}
